/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useRef, useState } from "react";

import { useAppDispatch, useAppSelector } from "store/store";

import { AnswerItem } from "./AnswerItem";
import { resetCurrentAnswer } from "store/slicer/GestioneSaveAnswerSlice";
import { getChatHistoryInactiveAnswers } from "services";
import { setChatHistory, setCheckInactiveAnswers } from "store/slicer/GestioneChatSlice";

export const ChatHistoryPage = ({
  projectId,
  showChat,
  openedChatFirstTime,
  chatHistoryPageHeight,
}: {
  projectId: string;
  showChat: boolean;
  openedChatFirstTime: boolean;
  chatHistoryPageHeight: string;
}) => {
  const chatHistory = useAppSelector(
    (state) => state.gestioneChatSlice.chatHistory
  );
  const filters = useAppSelector((state) => state.gestioneChatSlice.filters);
  const chatEndRef = useRef<HTMLDivElement | null>(null);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [selectedAnswers, setSelectedAnswers] = useState<number[]>([]);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const waitMessage = useAppSelector(
    (state) => state.gestioneChatSlice.waitMessage
  );
  const newMessage = useAppSelector(
    (state) => state.gestioneChatSlice.newMessage
  );
  const currentAnswer = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.currentAnswer
  );
  const openChat = useAppSelector((state) => state.gestioneChatSlice.openChat);

  const checkInactiveAnswers = useAppSelector(
    (state) => state.gestioneChatSlice.checkInactiveAnswers
  );

  useEffect(() => {
    if (checkInactiveAnswers) {
      getChatHistoryInactiveAnswers(projectId)
        .then((res) => {
          const inactiveAnswerIds = res.data ?? [];
          if (inactiveAnswerIds.length) {
            const updatedItems = chatHistory.items?.map((question) => ({
              ...question,
              answersList: question.answersList.map((answer) => ({
                ...answer,
                isActive: !inactiveAnswerIds.includes(answer.id),
              })),
            }));

            dispatch(setChatHistory({ ...chatHistory, items: updatedItems }));
          }

          dispatch(setCheckInactiveAnswers(false));
        })
        .catch(() => { });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkInactiveAnswers]);


  useEffect(() => {
    if (
      chatHistory.items &&
      chatHistory?.items?.length &&
      !currentAnswer &&
      firstLoad
    ) {
      document.querySelector("#chat")!.scrollTop =
        document.querySelector("#chat")!.scrollHeight;
    }
  }, [chatHistory.items, currentAnswer, openChat, firstLoad]);

  useEffect(() => {
    if (chatHistory.items && chatHistory?.items?.length && !newMessage) {
      document.querySelector("#chat")!.scrollTop =
        document.querySelector("#chat")!.scrollHeight;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waitMessage, newMessage]);

  useEffect(() => {
    if (chatHistory.items && chatHistory?.items?.length) {
      const answerLengths = chatHistory.items.map((question) => {
        return question.answersList.length - 1;
      });
      setSelectedAnswers(answerLengths);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentAnswer && openChat && chatHistory.items?.length && firstLoad) {
      if (currentAnswer?.questionId && chatHistory?.items?.length) {
        const question = chatHistory.items.find(
          (q) => q.id === currentAnswer.questionId
        );

        if (question) {
          const questionIndex = chatHistory.items.findIndex(
            (q) => q.id === currentAnswer.questionId
          );

          if (questionIndex !== -1) {
            const question = chatHistory.items[questionIndex];

            const answerIndex = question.answersList.findIndex(
              (a) => a.id === currentAnswer.id
            );

            if (answerIndex !== -1) {
              handleAnswerSelection(questionIndex, answerIndex);
              const answerElement = document.querySelector(
                `#answer-${currentAnswer.questionId}`
              );

              setTimeout(() => {
                if (answerElement) {
                  answerElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }
              }, 500);
            }
          }
        }
        dispatch(resetCurrentAnswer());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAnswer, chatHistory.items, openChat, firstLoad]);

  useEffect(() => {
    if (firstLoad && openChat) {
      setFirstLoad(false);
    }
    if (!firstLoad && !openChat) {
      setFirstLoad(true);
    }
  }, [firstLoad, openChat]);

  const handleAnswerSelection = (index: number, answerSelected: number) => {
    const updatedAnswers = [...selectedAnswers];
    updatedAnswers[index] = answerSelected;
    setSelectedAnswers(updatedAnswers);
  };

  return (
    <>
      <div
        id="chat"
        ref={chatContainerRef}
        className={`chat-history-container ${openedChatFirstTime} ${!openedChatFirstTime
          ? showChat
            ? "fadeInBottom"
            : "fadeOutBottom"
          : ""
          }`}
        style={{ height: chatHistoryPageHeight }}
      >
        {chatHistory.items?.map((item, index) => (
          <AnswerItem
            key={index}
            item={item}
            filters={filters}
            index={index}
            numberAnswerSelected={
              selectedAnswers[index] === -1 ? 0 : selectedAnswers[index] || 0
            }
            onAnswerSelect={(answerSelected: number) =>
              handleAnswerSelection(index, answerSelected)
            }
            selectorId={`answer-${item.id}`}
            isLast={index === chatHistory.items.length - 1}
          />
        ))}
      </div>
      <div ref={chatEndRef} />
    </>
  );
};
